import { render, staticRenderFns } from "./wish-table.vue?vue&type=template&id=56266204&scoped=true&"
import script from "./wish-table.vue?vue&type=script&lang=js&"
export * from "./wish-table.vue?vue&type=script&lang=js&"
import style0 from "./wish-table.vue?vue&type=style&index=0&id=56266204&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56266204",
  null
  
)

export default component.exports